function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  fillRule: "evenodd",
  d: "m19.56 6.56 1.73 1.73c.391.391.393 1.027.002 1.418L9.708 21.292a1.007 1.007 0 0 1-1.418-.002l-1.73-1.73A1.5 1.5 0 0 0 4.44 17.44l-1.73-1.73a1.004 1.004 0 0 1 0-1.417L14.291 2.708a1.006 1.006 0 0 1 1.418.002l1.73 1.73A1.5 1.5 0 0 0 19.56 6.56m-6.766.146-6.088 6.088c-.39.39-.382 1.03-.003 1.41l3.094 3.093c.388.388 1.025.38 1.409-.003l6.088-6.088c.39-.39.382-1.03.003-1.41l-3.094-3.093a1 1 0 0 0-1.409.003M16.5 10.5l-6 6-3-3 6-6z",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-ticket.svg";
export { SvgComponent as ReactComponent };